export const STATE = {
    INIT: 0,
    LOADING: 1,
    ERROR: 2,
    LOADED: 3,
}